<template>
  <div>
    <p class="tw:font-bold tw:text-2xl tw:mb-10">
      {{ `${$t('chatbot_greeting')}  ${$t('chatbot_greeting_subtext')}` }}
    </p>
    <p class="tw:text-sm tw:text-gray-700 tw:mb-2">{{ $t('chatbot_prompt') }}</p>
    <ul class="tw:flex tw:flex-col tw:gap-2 tw:mb-10">
      <li v-for="(chatOption, i) in initialChatOptions" :key="i">
        <button
          class="tw:px-4 tw:py-3 tw:w-full tw:text-left tw:text-sm tw:bg-blue-700 tw:text-white tw:rounded-lg tw:cursor-pointer tw:hover:bg-blue-800 tw:transition-colors tw:duration-300"
          @click="handleOptionClick($t(chatOption))"
        >
          {{ $t(chatOption) }}
        </button>
      </li>
    </ul>
    <i18n-t keypath="chatbot_disclaimer" tag="p" class="tw:text-xs tw:text-gray-600">
      <template #PrivacyPolicy>
        <BaseLink
          :href="getPrivacyPolicyUrl(language)"
          target="_blank"
          class="tw:cursor-pointer tw:hover:underline tw:text-blue-700"
        >
          {{ $t('legal.privacyPolicy').toLowerCase() }}
        </BaseLink>
      </template>
    </i18n-t>
  </div>
</template>

<script setup>
import BaseLink from '@/components/BaseLink.vue'
import useChat, { authors } from '@/components/chatbot/useChat'
import { getPrivacyPolicyUrl } from '@/utils/Utility.ts'
import { useSessionValues } from '@/composables/useSessionValues'
import appAnalytics from '@/utils/tracking'

const initialChatOptions = ['chatbot_question_1', 'chatbot_question_3', 'chatbot_question_4', 'chatbot_question_5']

const { language } = useSessionValues()
const { addMessage, conversationId } = useChat()

const handleOptionClick = option => {
  appAnalytics.track(appAnalytics.events.CHAT_PREDEFINED_OPTION_CLICKED, {
    conversation_id: conversationId.value,
    option,
  })
  addMessage(option, authors.USER)
}
</script>
